<template>
  <div class="container template-management-container">
    <el-card shadow="hover">
      <template #header>
        <div class="card-header">
          <h2>إدارة قوالب الشهادات</h2>
          <el-button type="primary" @click="handleCreate">
            <el-icon><Plus /></el-icon> إضافة قالب جديد
          </el-button>
        </div>
      </template>

      <el-table :data="templates" v-loading="loading" border style="width: 100%">
        <el-table-column prop="name" label="اسم القالب" />
        <el-table-column prop="description" label="الوصف" />
        <el-table-column label="الإعدادات المضمنة" min-width="350">
            <template #default="{ row }">
                <div v-if="row.layout_options" class="tag-container">
                    <!-- الخيارات القديمة -->
                    <el-tag v-if="row.layout_options.show_gpa" type="success" effect="light" style="margin: 2px;">عرض المعدل</el-tag>
                    <el-tag v-if="row.layout_options.show_attendance" type="info" effect="light" style="margin: 2px;">عرض الحضور</el-tag>
                    <el-tag v-if="row.layout_options.show_behavioral_evaluation" type="warning" effect="light" style="margin: 2px;">تقييم السلوك</el-tag>
                    <el-tag v-if="row.layout_options.show_teacher_remarks" type="warning" effect="light" style="margin: 2px;">ملاحظات المعلمين</el-tag>
                    <!-- الخيارات الجديدة للشهادة النهائية -->
                    <el-tag v-if="row.layout_options.show_term1_grades" effect="dark" style="margin: 2px;">درجات الفصل الأول</el-tag>
                    <el-tag v-if="row.layout_options.show_term2_grades" effect="dark" style="margin: 2px;">درجات الفصل الثاني</el-tag>
                    <el-tag v-if="row.layout_options.show_final_year_grade" type="danger" effect="light" style="margin: 2px;">الدرجة السنوية</el-tag>
                    <el-tag v-if="row.layout_options.show_grading_policy" type="primary" effect="light" style="margin: 2px;">سياسة التقييم</el-tag>
                    <el-tag v-if="row.layout_options.show_grading_scale_key" type="warning" effect="light" style="margin: 2px;">مفتاح التقديرات</el-tag>
                </div>
            </template>
        </el-table-column>
        <el-table-column label="الإجراءات" width="150" fixed="right">
          <template #default="{ row }">
            <el-button size="small" @click="handleEdit(row)">تعديل</el-button>
            <el-popconfirm title="هل أنت متأكد من حذف هذا القالب؟" @confirm="handleDelete(row.id)">
              <template #reference><el-button size="small" type="danger">حذف</el-button></template>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- Dialog لإنشاء/تعديل القالب -->
    <el-dialog v-model="dialogVisible" :title="dialogTitle" width="60%">
      <el-form :model="form" ref="formRef" label-position="top" :rules="rules">
        <el-form-item label="اسم القالب" prop="name">
          <el-input v-model="form.name" placeholder="مثال: شهادة المرحلة الثانوية" />
        </el-form-item>
        <el-form-item label="الوصف" prop="description">
          <el-input v-model="form.description" type="textarea" placeholder="وصف موجز للغرض من هذا القالب" />
        </el-form-item>
        
        <el-form-item label="محتوى رأس الصفحة المخصص (HTML)" prop="header_content">
          <el-input v-model="form.header_content" type="textarea" :rows="4" placeholder="يمكنك وضع HTML هنا ليظهر في رأس كل شهادة تستخدم هذا القالب" />
        </el-form-item>
        <el-form-item label="محتوى تذييل الصفحة المخصص (HTML)" prop="footer_content">
          <el-input v-model="form.footer_content" type="textarea" :rows="4" placeholder="يمكنك وضع HTML هنا ليظهر في تذييل كل شهادة" />
        </el-form-item>
        
        <el-divider>خيارات التخطيط والمحتوى</el-divider>
        <p class="form-tip">اختر الأقسام التي تود إظهارها في هذا القالب. يمكنك اختيار خيارات للشهادة الفصلية أو السنوية أو كلاهما.</p>
        
        <div class="options-grid">
            <div class="option-group">
                <h5>خيارات الشهادة النهائية</h5>
                <el-checkbox v-model="form.layout_options.show_term1_grades" label="إظهار درجات الفصل الأول" border />
                <el-checkbox v-model="form.layout_options.show_term2_grades" label="إظهار درجات الفصل الثاني" border />
                <el-checkbox v-model="form.layout_options.show_final_year_grade" label="إظهار الدرجة السنوية للمادة" border />
                <el-checkbox v-model="form.layout_options.show_subject_status" label="إظهار حالة المادة (ناجح/راسب)" border />
                <el-checkbox v-model="form.layout_options.show_min_passing_score" label="إظهار درجة النجاح" border />
                <el-checkbox v-model="form.layout_options.show_overall_summary" label="إظهار الملخص النهائي (المعدل وحالة الترفيع)" border />
            </div>
            <div class="option-group">
                <h5>خيارات إضافية</h5>
                <el-checkbox v-model="form.layout_options.show_gpa" label="إظهار المعدل التراكمي (GPA)" border />
                <el-checkbox v-model="form.layout_options.show_attendance" label="إظهار ملخص الحضور والغياب" border />
                <el-checkbox v-model="form.layout_options.show_behavioral_evaluation" label="إظهار قسم تقييم السلوك" border />
                <el-checkbox v-model="form.layout_options.show_teacher_remarks" label="إظهار ملاحظات المعلمين" border />
                <el-checkbox v-model="form.layout_options.show_grading_policy" label="إظهار تفاصيل سياسة التقييم" border />
                <el-checkbox v-model="form.layout_options.show_grading_scale_key" label="إظهار مفتاح التقديرات" border />
            </div>
        </div>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisible = false">إلغاء</el-button>
          <el-button type="primary" @click="submitForm" :loading="formLoading">حفظ القالب</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios';
import { ElMessage, ElPopconfirm } from 'element-plus';
import { Plus } from '@element-plus/icons-vue';

export default {
  name: 'ReportCardTemplateManagement',
  components: { Plus, ElPopconfirm },
  data() {
    return {
      api: null,
      templates: [],
      loading: false,
      dialogVisible: false,
      formLoading: false,
      form: this.getInitialForm(),
      rules: {
        name: [{ required: true, message: 'اسم القالب مطلوب', trigger: 'blur' }],
      },
      logoFile: null,
      logoPreview: '',
    };
  },
  computed: {
    dialogTitle() {
      return this.form.id ? 'تعديل قالب الشهادة' : 'إنشاء قالب شهادة جديد';
    },
  },
  created() {
    this.api = axios.create({ baseURL: process.env.VUE_APP_API_BASE_URL || 'https://cale.caledonian.ly/api' });
    this.api.interceptors.request.use((config) => {
      const token = localStorage.getItem('access_token');
      if (token) config.headers['Authorization'] = `Bearer ${token}`;
      return config;
    });
    this.fetchTemplates();
  },
  methods: {
    getInitialForm() {
      return {
        id: null, name: '', description: '', type: 'report_card',
        template_view_path: '', header_content: '', footer_content: '', logo_path: '',
        layout_options: {
          show_gpa: false,
          show_attendance: false,
          show_behavioral_evaluation: false,
          show_teacher_remarks: false,
          show_term1_grades: false,
          show_term2_grades: false,
          show_final_year_grade: false,
          show_subject_status: false,
          show_min_passing_score: false,
          show_overall_summary: false,
          show_grading_policy: false,
          show_grading_scale_key: false,
        }
      };
    },
    async fetchTemplates() {
      this.loading = true;
      try {
        const response = await this.api.get('/report-card-templates');
        this.templates = response.data;
      } catch (error) { ElMessage.error('Failed to fetch templates.'); } 
      finally { this.loading = false; }
    },
    handleCreate() {
      this.form = this.getInitialForm();
      this.logoFile = null;
      this.logoPreview = '';
      this.dialogVisible = true;
    },
    handleEdit(template) {
      this.form = JSON.parse(JSON.stringify(template));
      this.form.layout_options = {
        ...this.getInitialForm().layout_options,
        ...template.layout_options
      };
      this.logoPreview = template.logo_url;
      this.logoFile = null;
      this.dialogVisible = true;
    },
    handleLogoChange(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        ElMessage.error('Logo image can not exceed 2MB!');
        return;
      }
      this.logoFile = file.raw;
      this.logoPreview = URL.createObjectURL(file.raw);
    },
    async submitForm() {
      if (!this.$refs.formRef) return;
      await this.$refs.formRef.validate(async (valid) => {
        if (!valid) return;
        this.formLoading = true;
        
        const formData = new FormData();
        for (const key in this.form) {
          if (key === 'layout_options' && this.form[key]) {
             formData.append(key, JSON.stringify(this.form[key]));
          } else if (this.form[key] !== null) {
            formData.append(key, this.form[key]);
          }
        }
        if (this.logoFile) {
          formData.append('logo', this.logoFile);
        }

        try {
          if (this.form.id) {
            formData.append('_method', 'PUT');
            await this.api.post(`/report-card-templates/${this.form.id}`, formData, {
              headers: { 'Content-Type': 'multipart/form-data' }
            });
            ElMessage.success('Template updated successfully!');
          } else {
            await this.api.post('/report-card-templates', formData, {
              headers: { 'Content-Type': 'multipart/form-data' }
            });
            ElMessage.success('Template created successfully!');
          }
          this.dialogVisible = false;
          this.fetchTemplates();
        } catch (error) {
            const errorMsg = error.response?.data?.errors ? Object.values(error.response.data.errors)[0][0] : (error.response?.data?.message || 'Operation failed.');
            ElMessage.error(errorMsg);
        } finally { this.formLoading = false; }
      });
    },
    async handleDelete(id) {
        try {
            await this.api.delete(`/report-card-templates/${id}`);
            ElMessage.success('Template deleted successfully!');
            this.fetchTemplates();
        } catch (error) {
            ElMessage.error(error.response?.data?.message || 'Failed to delete template.');
        }
    }
  },
};
</script>

<style scoped>
.template-management-container { padding: 20px; }
.card-header { display: flex; justify-content: space-between; align-items: center; }
.form-tip { font-size: 0.85em; color: #909399; margin-top: -10px; margin-bottom: 15px; }
.el-checkbox.is-bordered { margin-bottom: 10px; margin-right: 10px !important; }
.logo-uploader .el-upload { border: 1px dashed #d9d9d9; border-radius: 6px; cursor: pointer; position: relative; overflow: hidden; }
.logo-uploader .el-upload:hover { border-color: #409EFF; }
.logo-uploader-icon { font-size: 28px; color: #8c939d; width: 178px; height: 178px; text-align: center; line-height: 178px; }
.logo { width: 178px; height: 178px; display: block; object-fit: contain; }
.options-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
}
.option-group {
    border: 1px solid #eee;
    padding: 15px;
    border-radius: 8px;
}
.option-group h5 {
    margin-top: 0;
    margin-bottom: 15px;
    border-bottom: 1px solid #f0f0f0;
    padding-bottom: 10px;
}
</style>
